const HelpIcon = ({ className }: { className?: string }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.82817 6.375C6.21704 5.54979 7.26608 4.95833 8.5 4.95833C10.0654 4.95833 11.3333 5.90962 11.3333 7.08333C11.3333 8.075 10.4281 8.90729 9.20408 9.14246C8.82017 9.21612 8.5 9.52496 8.5 9.91667M8.5 12.0417H8.50708M14.875 8.5C14.875 9.33718 14.7101 10.1662 14.3897 10.9396C14.0694 11.7131 13.5998 12.4158 13.0078 13.0078C12.4158 13.5998 11.7131 14.0694 10.9396 14.3897C10.1662 14.7101 9.33718 14.875 8.5 14.875C7.66282 14.875 6.83384 14.7101 6.06039 14.3897C5.28694 14.0694 4.58417 13.5998 3.99219 13.0078C3.40022 12.4158 2.93064 11.7131 2.61027 10.9396C2.28989 10.1662 2.125 9.33718 2.125 8.5C2.125 6.80924 2.79665 5.18774 3.99219 3.99219C5.18774 2.79665 6.80924 2.125 8.5 2.125C10.1908 2.125 11.8123 2.79665 13.0078 3.99219C14.2033 5.18774 14.875 6.80924 14.875 8.5Z"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default HelpIcon;
